"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeader = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../../utils");

var _layout = require("../../layout");

var _context = require("../../context");

var _propTypes = require("../../prop-types");

var _PageContainer = require("../PageContainer");

var _constants = require("./constants");

var _core = require("@emotion/core");

var HeaderRow = (0, _context.styledWithTheme)(_layout.View.withComponent('header', {
  target: "emwj0d80"
}))(function (_ref) {
  var hasShadow = _ref.hasShadow,
      isFixed = _ref.isFixed,
      selectors = _ref.theme.selectors,
      top = _ref.top;
  var backgroundColor = selectors.color(_constants.PAGE_HEADER_BACKGROUND_COLOR);
  var styles = {
    alignItems: 'center',
    backgroundColor: backgroundColor,
    boxShadow: hasShadow ? "0px 0px 10px ".concat((0, _utils.opacify)(backgroundColor, 0.2)) : 'none',
    display: 'inline-block',
    height: selectors.constant('headerHeight'),
    left: 0,
    minWidth: '100%',
    top: top
  };
  return isFixed ? (0, _objectSpread2.default)({}, styles, {
    position: 'fixed',
    zIndex: selectors.zIndex('header')
  }) : styles;
});
var PageHeaderDefaultProps = {
  isFullWidth: false,
  hasShadow: false,
  isFixed: false,
  top: 0
};

var PageHeaderBase = function PageHeaderBase(_ref2) {
  var children = _ref2.children,
      _ref2$isFullWidth = _ref2.isFullWidth,
      isFullWidth = _ref2$isFullWidth === void 0 ? PageHeaderDefaultProps.isFullWidth : _ref2$isFullWidth,
      _ref2$hasShadow = _ref2.hasShadow,
      hasShadow = _ref2$hasShadow === void 0 ? PageHeaderDefaultProps.hasShadow : _ref2$hasShadow,
      _ref2$isFixed = _ref2.isFixed,
      isFixed = _ref2$isFixed === void 0 ? PageHeaderDefaultProps.isFixed : _ref2$isFixed,
      dataTestId = _ref2.dataTestId,
      _ref2$top = _ref2.top,
      top = _ref2$top === void 0 ? PageHeaderDefaultProps.top : _ref2$top;

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilReactPageHeader',
    dataTestId: dataTestId
  });
  return (0, _core.jsx)(_layout.View, {
    margin: {
      top: top
    }
  }, (0, _core.jsx)(HeaderRow, (0, _extends2.default)({}, dataTestProps, {
    hasShadow: hasShadow,
    isFixed: isFixed,
    top: top
  }), (0, _core.jsx)(_PageContainer.PageContainer, {
    paddingBottom: "0",
    paddingTop: "0",
    display: "flex",
    height: "100%",
    alignItems: "center",
    isFullWidth: isFullWidth
  }, children)), isFixed && (0, _core.jsx)(_layout.Spacer, {
    height: selectors.constant('headerHeight')
  }));
};

var PageHeader = (0, _stencilReactDesc.describe)(PageHeaderBase).description('Page header with base functionality.');
exports.PageHeader = PageHeader;
PageHeader.displayName = 'PageHeader';
PageHeader.defaultProps = PageHeaderDefaultProps;
PageHeader.propTypes = {
  top: (0, _propTypes.cssValue)().description('Sets the spacing from the top, especially useful when "fixed" is true.'),
  hasShadow: _stencilReactDesc.PropTypes.bool.description('Determines whether to render a shadow.'),
  isFixed: _stencilReactDesc.PropTypes.bool.description('Determines whether to fix the header to the top of the page.'),
  isFullWidth: _stencilReactDesc.PropTypes.bool.description("Determines whether to ignore theme's maxWidth and apply full width.")
};